import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";
import { SellCustomerGroup } from "../../models/sell-customer-group.model";

@Component({
  selector: "ngx-sell-customer-group-form",
  templateUrl: "./sell-customer-group-form.component.html",
  styleUrls: ["./sell-customer-group-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SellCustomerGroupFormComponent extends BaseFormComponent<SellCustomerGroup> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "SellCustomerGroup";
    this.label = "گروهبندی مشتری";
    super.ngOnInit();
  }
  setdefault() {
    if (this.parentrow && !this.model.ParentId) {
      this.model.ParentId = this.parentrow.Id;
      this.setValue("ParentId", this.model.ParentId);
    }
    if (!this.isNewRow && this.model.ParentId) {
      this.httpCommonService
        .getItem<SellCustomerGroup>(this.apiName, this.model.ParentId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.parentrow = Object.assign({}, data as SellCustomerGroup);
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  beforupdate() {
    if (this.parentrow && this.parentrow.TreeCode) {
      this.model.TreeCode =
        (!this.parentrow.TreeCode ? "" : this.parentrow.TreeCode) +
        (!this.formGroup.controls["Code"].value ? "" : this.formGroup.controls["Code"].value);
      this.model.TreePath =
        (!this.parentrow.TreePath ? "" : this.parentrow.TreePath) +
        " " +
        (!this.formGroup.controls["Title"].value ? "" : this.formGroup.controls["Title"].value);
    } else {
      this.model.TreeCode = this.formGroup.controls["Code"].value;
      this.model.TreePath = this.formGroup.controls["Title"].value;
    }
    this.setValue("TreeCode", this.model.TreeCode);
    this.setValue("TreePath", this.model.TreePath);
  }
}
